<label for="{{controlName}}" class="{{classValue}}">
    <ng-content></ng-content>
    <span class="text-danger" *ngIf="required">&nbsp;*</span>
    <i class="ps-1 bi bi-info-circle-fill" *ngIf="info"></i>
</label>
